import './load-card-reoffer-modal.scss';
import { ClbModal } from '@celebration/react';
import { ButtonPropsModal } from '@celebration/react/ClbModal/ClbModal.types';
import { useTranslation } from 'react-i18next';
import ILoadCardReOfferModalProps from '../../interfaces/ILoadCardReOfferModalProps';

function LoadCardReOfferModal({
    reOfferModalOpen,
    reOfferModalOnClose,
    reOfferModalOnCancel,
    reOfferModalOnReOffer,
}: Readonly<ILoadCardReOfferModalProps>) {
    const { t } = useTranslation();

    const footerButtons: [ButtonPropsModal, ButtonPropsModal] = [
        {
            'data-testid': 'reOffer-load-confirmation-modal-reOffer-button',
            key: 'reOffer-load-confirmation-modal-reOffer-button',
            type: 'button',
            styleType: 'primary',
            size: 'sm',
            iconPosition: 'none',
            disabled: false,
            loading: false,
            blockedWidth: false,
            label: t('Reofertar'),
            role: 'button',
            onClick: reOfferModalOnReOffer,
        },
        {
            'data-testid': 'reOffer-load-confirmation-modal-cancel-button',
            key: 'reOffer-load-confirmation-modal-cancel-button',
            type: 'button',
            styleType: 'secondary',
            size: 'sm',
            iconPosition: 'none',
            disabled: false,
            loading: false,
            blockedWidth: false,
            label: t('Cancelar'),
            role: 'button',
            onClick: reOfferModalOnCancel,
        },
    ];

    return (
        <div data-testid="load-card-reoffer-modal">
            <ClbModal
                itemsFooter={footerButtons}
                title={t('ReofertarLoadTituloModal')}
                size="lg"
                open={reOfferModalOpen}
                onClose={reOfferModalOnClose}
            />
        </div>
    );
}

export default LoadCardReOfferModal;
